
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { CloseButton } from '@/modules/common/components/buttons';
import ExchangeContentBlock from './ExchangeContentBlock.vue';
import {
  Heading,
  Row,
  BaseModal,
  BaseText,
  NavBar,
  RoundedIcon,
  LoaderIndicator
} from '@warrenbrasil/nebraska-web';
import { moneyFormat } from '@/modules/common/helpers/currency';
import {
  ExchangeAPI,
  TransactionData,
  ExchangeStatus
} from '@/modules/transaction/services/exchange';
import DEFAULT_TRANSACTION_DATA from './default-transaction-data';
import STATUS_CONTENT, { ContentData as StatusContent } from './status-content';

@Component({
  components: {
    BaseModal,
    CloseButton,
    LoaderIndicator,
    Row,
    Heading,
    NavBar,
    BaseText,
    RoundedIcon,
    ExchangeContentBlock
  }
})
export default class ExchangeTransferModal extends Vue {
  @Prop({ type: String, required: true })
  private id!: string;

  @Prop({ type: Boolean, default: false })
  private isOpen!: boolean;

  public isLoading = true;
  public transactionData: TransactionData = DEFAULT_TRANSACTION_DATA;
  public NebraskaColors = NebraskaColors;
  private exchangeAPI = new ExchangeAPI();

  public get isFfcTransfer() {
    return (
      !!this.transactionData.forFurtherCreditAccount &&
      !!this.transactionData.forFurtherCreditName
    );
  }

  public get bankCodeLabel() {
    const firstPart = `Código ${this.isSwiftCode ? 'SWIFT' : 'ABA Number'}`;

    return `${firstPart} ${
      this.isFfcTransfer
        ? 'do banco intermediário'
        : 'da Instituição favorecida'
    }`;
  }

  public get isSwiftCode() {
    return !!this.transactionData.bankSWIFTCode;
  }

  public get currencyNetValue() {
    return moneyFormat(this.transactionData.netValue);
  }

  public get statusBasedContent(): StatusContent {
    const currentStatus =
      this.transactionData.status.toLowerCase() as ExchangeStatus;

    const content = STATUS_CONTENT[currentStatus];

    return content ?? STATUS_CONTENT.scheduled;
  }

  public get tradedCurrencyAmount() {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: this.transactionData.symbolCurrencyQuote
    }).format(this.transactionData.tradedCurrencyAmount);
  }

  mounted() {
    this.loadData();
  }

  @Watch('id')
  private async loadData() {
    if (!this.id) {
      this.closeModal();

      return;
    }

    this.isLoading = true;

    try {
      this.transactionData = await this.exchangeAPI.getExchange(this.id);
    } catch (e) {
      this.closeModal();
    } finally {
      this.isLoading = false;
    }
  }

  private closeModal() {
    this.$emit('close');
  }
}
